export default __webpack_public_path__ + "static/media/faq.42767c94.svg";